import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { NgClass } from '@angular/common';

export type NotificationDialogType = 'error' | 'success' | 'warning';

export interface NotificationDialogConfig {
  type: NotificationDialogType;
  title?: string;
  message: string;
}

const DEFAULTS: Record<NotificationDialogType, { title: string; icon: string }> = {
  error:   { title: 'Error',   icon: '../../../../../assets/error.png' },
  success: { title: 'Success', icon: '../../../../../assets/success.png' },
  warning: { title: 'Warning', icon: '../../../../../assets/warning.png' }
};

@Component({
  selector: 'app-notification-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, NgClass],
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationDialogComponent {
  readonly type: NotificationDialogType;
  readonly title: string;
  readonly message: string;
  readonly iconSrc: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: NotificationDialogConfig,
    private readonly dialogRef: MatDialogRef<NotificationDialogComponent>
  ) {
    const defaults = DEFAULTS[data.type];
    this.type = data.type;
    this.title = data.title ?? defaults.title;
    this.message = data.message;
    this.iconSrc = defaults.icon;
  }

  close(): void {
    this.dialogRef.close();
  }
}
